import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import PropTypes from 'prop-types';

import { FormattedMessage, SplitFormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Heading from '@zenbusiness/zui/Heading';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import Stack from '@zenbusiness/zui/Stack';

import * as Styled from './Information.styles';
import { messageFormatValues } from '../../../../utils/messageFormatValues';

const SubDescriptionComponent = ({ children }) => (
  <Styled.SubDescription>
    <CheckIcon
      color="success"
      sx={{ width: '1rem', height: '1rem' }}
    />
    {children}
  </Styled.SubDescription>
);

const Information = ({
  items, hasIcon, hasNumber, hasDivider, disclaimers = []
}) => (
  <List sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 3
  }}
  >
    {items.map((item, index) => {
      const formattedDescription = hasIcon ? SplitFormattedMessage({
        id: item.description,
        delimiter: '\n',
        component: SubDescriptionComponent
      }) : null;

      return (
        <React.Fragment key={`${item.title}-${index.toString()}`}>
          <ListItem
            sx={{ padding: 0 }}
          >
            {hasNumber && (
              <Styled.IconStep>
                {index + 1}
              </Styled.IconStep>
            )}
            <Stack gap={hasIcon ? 3 : 1}>
              {!!item.title && (<Heading size="md"><FormattedMessage id={item.title} /></Heading>)}
              {!!item.description && (
                <Styled.Description color="secondary">
                  {hasIcon
                    ? formattedDescription
                    : <FormattedMessage id={item.description} values={messageFormatValues} />}
                </Styled.Description>
              )}
            </Stack>
          </ListItem>
          {hasDivider && index !== items.length - 1 && <Divider />}
        </React.Fragment>
      );
    })}
    {disclaimers?.length > 0 && (
      <>
        <Divider />
        <ListItem key="disclaimers" sx={{ padding: 0 }}>
          <Stack gap={1}>
            {disclaimers?.map((disclaimer) => (
              <Styled.Disclaimer key={disclaimer} size="sm" color="secondary">
                <FormattedMessage id={disclaimer} />
              </Styled.Disclaimer>
            ))}
          </Stack>
        </ListItem>
      </>
    )}
  </List>
);

Information.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string
    })
  ),
  hasIcon: PropTypes.bool,
  hasNumber: PropTypes.bool,
  hasDivider: PropTypes.bool,
  disclaimers: PropTypes.arrayOf(PropTypes.string)
};

export default Information;
